/**
 * CQTex Command Centre module contract shapes (cqtex-command/MODULE_CONTRACT.md).
 * Protocol identifiers keep the `hub` prefix literally: iss "cqtex-hub",
 * token types "hub-service" / "module-launch", paths /api/hub/*, route /hub-auth.
 */
export const MODULE_KEY = 'cortex';
export const MODULE_ROLES = ['ADMIN', 'ENGINEER', 'VIEWER'];
//# sourceMappingURL=module.js.map